import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=1a1d1453&scoped=true"
import script from "./Active.vue?vue&type=script&lang=js"
export * from "./Active.vue?vue&type=script&lang=js"
import style0 from "./Active.vue?vue&type=style&index=0&id=1a1d1453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d1453",
  null
  
)

export default component.exports